export default __webpack_public_path__ + "static/media/SFUIText-Semibold.3dc9a149.woff";